import { useCallback } from "react";
import CryptoJS from "crypto-js";
import useAppContext from "../context/useAppContext";

export const formatPhone = (raw) => {
  if (!raw) return undefined;
  const normalized = `${raw}`.replace(/\s+/g, "").replace(/[()\-]/g, "");
  if (!normalized) return undefined;

  if (normalized.startsWith("+")) {
    return normalized;
  }

  const digits = normalized.replace(/\D/g, "");
  if (!digits) return undefined;
  if (digits.length === 10) return `+90${digits}`;
  if (digits.length === 11 && digits.startsWith("0")) return `+9${digits}`;
  if (digits.startsWith("90")) return `+${digits}`;

  return `+${digits}`;
};

export const hashEmail = (raw) => {
  if (!raw) return undefined;
  const trimmed = `${raw}`.trim().toLowerCase();
  if (!trimmed) return undefined;
  return CryptoJS.SHA256(trimmed).toString(CryptoJS.enc.Hex);
};

const stepConfig = ({ step, payload }) => {
  switch (step) {
    case 'initial':
      return { event: "step_1_basic_info", ...payload };
    case 'otp':
      return { event: "step_2_sms_otp", ...payload };
    case 1:
      return { event: "step_3_personal_info", ...payload };
    case 2:
      return { event: "step_5_investor_info", ...payload };
    case 3:
      return { event: "step_6_account_opening", ...payload };
    case "final":
      return {
        event: "account_created",
        ...payload,
      };
    default:
      return { event: step, ...payload };
  }
};

const useGtmEvent = () => {
  const { innerTexts } = useAppContext();
  const enabled = innerTexts.gtmEvent ?? false;

  const sendGTMEvent = useCallback(
    ({ step, payload }) => {
      if (!enabled) return;
      const data = stepConfig({ step, payload });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    },
    [enabled]
  );

  return { sendGTMEvent };
};

export default useGtmEvent;